<template>
  <div
    class="dataGridCell"
    :ref="'dataGridCell_' + Object.values(myid).join('')"
    :class="[
      `container_id_${myid.container_id}-rect_id_${myid.rect_id}-cell_id_${myid.cellId}`,
    ]"
    @click.stop.prevent="clickCellBox"
    @drop.stop="handleDataGridDragover($event)"
    @mouseenter.stop
    :style="getCellStyle"
    v-show="options.isShow"
  >
    <template v-if="isActiveCell || isDragover">
      <div
        v-for="handle in borderList"
        :key="handle"
        :class="['handle', 'handle-' + handle, (isActiveCell && ids.cellId === 'root') || isDragover ? 'active' : '']"
      >
        <slot :name="handle"></slot>
      </div>
    </template>
    <p class="emptyColText" v-if="myid.cellId === 'root' && elementOptions.length === 0">从左侧工具栏拖拽添加组件</p>
    <div
      v-if="options.showRowColLayout"
      class="auto-layout-content scroller dataGrid-cell-layout"
      :class="[
        options.rowColDirection !== 'horizon' ? 'vertical' : 'horizon',
        options.showRowColLayout ? 'row-col-layout' : '']"
        :style="{...getAutoLayoutContentStyle, ...getOverStyle}"
    >
      <vueDragResizable
        v-for="(elementOption, index) in elementOptions"
        :class="[`container_id_${myid.container_id}-rect_id_${myid.rect_id}-cell_id_${myid.cellId}-elementInDataGridId_${elementOption.elementInDataGridId}`,
          myid.rect_id === ids.rect_id && elementOption.elementInDataGridId === ids.elementInDataGridId && myid.cellId==='root' ? 'active' : '',
          isDragover && insertIndex - 1 === index && (insertIndex - 1 > activeIndex || currentHalf) ? 'ghost after' : isDragover && insertIndex - 1 === index && (insertIndex - 1 < activeIndex || !currentHalf) ? 'ghost before' : ''
        ]"
        :key="index"
        :data-innerElement="'element is:' + elementOption.innerElement"
        :parent="true"
        :zoom="zoom"
        :snapWithAdsorbent="true"
        :options="elementOption"
        :rectId="myid.rect_id"
        :shape="elementOption.innerElement"
        :elementInDataGridId="elementOption.elementInDataGridId"
        :elementName="elementOption.innerElement"
        :active="myid.rect_id === ids.rect_id && elementOption.elementInDataGridId === ids.elementInDataGridId && myid.cellId
        ===
        'root'"
        :parentW="getParentW"
        :parentH="getParentH"
        :w="elementOption.width"
        :h="elementOption.height"
        :x="0"
        :y="0"
        v-on:resizing="resizingEv"
        v-on:resizeStop="resizestopEv"
        v-on:dragging="draggingEv"
        v-on:dragStop="dragstopEv"
        v-on:activated="activeEv(elementOption)"
        @click.stop.prevent
        @mouseup.stop.prevent
        @mousedown.stop.prevent
        :resizable="true"
        :draggable="true"
        @refLineParams="getRefLineParams"
        :handles="checkHandles()"
        :myId="{ ...myid, elementInDataGridId: elementOption.elementInDataGridId, cellId: myid.cellId }"
      >
        <!-- 复杂组件激活状态打开设置项才能选中子组件 -->
        <component
          class="rect"
          :options="elementOption"
          :myid="{
                ...myid,
                elementInDataGridId: elementOption.elementInDataGridId,
              }"
          :is="elementOption.innerElement"
        >
        </component>
      </vueDragResizable>
    </div>
    <div class="dataGrid-cell-layout" v-else style="height:100%">
      <vueDragResizable
        v-for="(elementOption, index) in elementOptions"
        :class="[`container_id_${myid.container_id}-rect_id_${myid.rect_id}-cell_id_${myid.cellId}-elementInDataGridId_${elementOption.elementInDataGridId}`, 
        myid.rect_id === ids.rect_id && elementOption.elementInDataGridId === ids.elementInDataGridId && myid.cellId === 'root' ? 'active' : '',]"
        :key="index"
        :data-innerElement="'element is:' + elementOption.innerElement"
        :parent="true"
        :zoom="zoom"
        :snapWithAdsorbent="true"
        :options="elementOption"
        :rectId="myid.rect_id"
        :shape="elementOption.innerElement"
        :active="myid.rect_id === ids.rect_id && elementOption.elementInDataGridId === ids.elementInDataGridId && myid.cellId === 'root'"
        :elementInDataGridId="elementOption.elementInDataGridId"
        :elementName="elementOption.innerElement"
        :parentW="getParentW"
        :parentH="getParentH"
        :w="elementOption.width"
        :h="elementOption.height"
        :x="elementOption.left"
        :y="elementOption.top"
        v-on:resizing="resizingEv"
        v-on:resizeStop="resizestopEv"
        v-on:dragging="draggingEv"
        v-on:dragStop="dragstopEv"
        v-on:activated="activeEv(elementOption)"
        @click.stop.prevent
        @mouseup.stop.prevent
        @mousedown.stop.prevent
        :resizable="true"
        :draggable="true"
        @refLineParams="getRefLineParams"
        :handles="checkHandles()"
        :myId="{ ...myid, elementInDataGridId: elementOption.elementInDataGridId, cellId: myid.cellId }"
      >
        <!-- 复杂组件激活状态打开设置项才能选中子组件 -->
        <component
          class="rect"
          :options="elementOption"
          :myid="{
                ...myid,
                elementInDataGridId: elementOption.elementInDataGridId,
              }"
          :is="elementOption.innerElement"
        >
        </component>
      </vueDragResizable>
    </div>
    <!--辅助线 -->
    <template>
        <span
          class="ref-line v-line"
          v-for="item in vLine"
          :key="item.id"
          v-show="item.display"
          :style="{
            left: item.position,
            top: item.origin,
            height: item.lineLength
          }"
        />
      <span
        class="ref-line h-line"
        v-for="item in hLine"
        :key="item.id"
        v-show="item.display"
        :style="{
            top: item.position,
            left: item.origin,
            width: item.lineLength
          }"
      />
    </template>
    <!--辅助线END-->
  </div>
</template>
<script>
import { _throttle } from "utils/index"
import VueDragResizable from "components/publicComponent/vueDragRiseable/vue-drag-resizable.vue"
import componentsMixin from "./componentsMixin.js"
import animateMixin from "utils/event/animateMixin.js"
import { getSyetemModuleJson } from "@/utils/initEv.js"
export default {
  name: "dataGridCell",
  mixins: [componentsMixin, animateMixin],
  components: {
    VueDragResizable
  },
  props: {
    options: {
      type: Object,
      default: null
    },
    parentOptions: {
      type: Object,
      default: null
    },
    elementOptions: {
      type: Array,
      default: null
    },
    myid: {
      type: Object,
      default: null
    },
    zoom: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      borderList: ["tb", "rb", "bb", "lb"],
      vLine: [],
      hLine: [],
      isDragover: false,
      insertIndex: null,
      activeIndex: -1, // 激活组件
      currentHalf: false, //当前位置是否超过当前元素的一半
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    getParentW() {
      const el = this.$refs["dataGridCell_" + Object.values(this.myid).join('')]
      return el?.getBoundingClientRect()?.width / this.zoom
      // let paddingW = this.parentOptions.paddingLeft + this.parentOptions.paddingRight
      // const columnGap = this.parentOptions.columnGap * (this.parentOptions.col - 1)
      // const gridW = (boundWidth - columnGap) / this.parentOptions.col
    },
    getParentH() {
      const el = this.$refs["dataGridCell_" + Object.values(this.myid).join('')]
      return el?.getBoundingClientRect()?.height / this.zoom
      // let paddingH = this.parentOptions.paddingTop + this.parentOptions.paddingBottom
      // const rowGap = this.parentOptions.rowGap * (this.parentOptions.row - 1)
      // const gridH = (boundHeight - rowGap) / this.parentOptions.row
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          // tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.options.boxShadowColor[index]}`
          tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        // tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.options.boxShadowColor}`
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (this.options.paddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor ? this.themeColor : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    getCellStyle() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      let style = {
        ...this.bgStyle,
        opacity: this.options.opacity / 100,
        "border-style": this.options.borderStyle,
        // "border-color": this.options.borderIsThemeColor
        //   ? this.themeColor
        //   : this.options.borderColor?.color
        //     ? this.options.borderColor?.color
        //     : this.options.borderColor,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        "border-width": this.options.showBorder !== false ? borderW : 0,
        "box-shadow": this.boxShadowStyle,
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        padding: this.getPaddingStyle,
        outline: this.elementOptions?.length > 0 ? "none" : "1px dashed var(--thirdTextColor)",
        "position": "relative",
      }
      if (this.myid.cellId !== "root") {
        style.filter = 'opacity(60%)'
      }
      return style
    },
    getAutoLayoutContentStyle () {
      let options = this.options
      let alignItems = "start"
      let justifyContent = "start"
      let alignContent = "start"
      switch (options.rowColAlignPositionH) {
        case "left":
          alignItems = "start"
          break
        case "center":
          alignItems = "center"
          break
        case "right":
          alignItems = "end"
          break
      }
      switch (options.rowColAlignPositionV) {
        case "top":
          justifyContent = "start"
          break
        case "middle":
          justifyContent = "center"
          break
        case "bottom":
          justifyContent = "end"
          break
      }
      if (options.rowColDirection === "horizon") {
        alignContent = justifyContent
      } else {
        alignContent = alignItems
      }
      let marginBottom = "" //行布局为下边距 列布局为右边距
      let marginRight = "" //行布局为右边距 列布局为下边距
      let rowGap = ""
      let columnGap = ""
      // 开启自动行列布局
      marginBottom = options.marginType !== 'auto' ? options.rowColMargin + "px" : ""
      if (options.autoWrap) {// 开启自动换行
        marginRight = options.rowColMarginRight + "px"
      }
      if (options.rowColDirection === 'horizon') {
        columnGap = options.marginType !== 'auto' ? marginBottom : ""
        rowGap = marginRight
      } else {
        rowGap = options.marginType !== 'auto' ? marginBottom : ""
        columnGap = marginRight
      }
      return {
        display: "flex",
        "align-content": options.autoWrap ? alignContent : "", //换行后显示格式
        "flex-direction": options.rowColDirection === "horizon" ? "row" : "column",
        "flex-wrap": options.autoWrap ? "wrap" : "nowrap",// 是否换行
        "align-items": options.rowColDirection === "horizon" ? justifyContent : alignItems,// 水平对齐格式
        "justify-content": options.marginType === "auto" ? "space-between" : options.rowColDirection === "horizon" ? alignItems : justifyContent, // 垂直对齐格式
        "row-gap": rowGap, // 行间距
        "column-gap": columnGap // 列间距
      }
    },
    // 溢出判断显示隐藏滚动
    getOverStyle() {
      let style = {}
      let overflow = ""
      if (this.options.overFlowType === "scroll") {
        overflow = "scroll"
      } else {
        overflow = this.options.overFlowType
      }
      let rowColDirection = this.options.rowColDirection
      if (rowColDirection === "horizon") {
        if (!this.options.autoWrap) {
          style = {
            "overflow-x": overflow ? overflow : "hidden",
            "overflow-y": overflow === "visible" ? "unset" : "hidden"
          }
        } else {
          style = {
            "overflow-y": overflow ? overflow : "hidden",
            "overflow-x": overflow === "visible" ? "unset" : "hidden"
          }
        }

      } else {
        if (!this.options.autoWrap) {
          style = {
            "overflow-y": overflow ? overflow : "hidden",
            "overflow-x": overflow === "visible" ? "unset" : "hidden"
          }
        } else {
          style = {
            "overflow-x": overflow ? overflow : "hidden",
            "overflow-y": overflow === "visible" ? "unset" : "hidden"
          }
        }

      }
      return style
    },
    isActiveCell() {
      // 激活单元格中的组件的时候不能激活单元格
      let flag = this.ids.rect_id === this.myid.rect_id && this.ids.cellId === this.myid.cellId
      if (this.ids.elementInDataGridId) {
        flag = false
      }
      return flag
    }
  },
  methods: {
    // 辅助线回调事件
    getRefLineParams(params) {
      const { vLine, hLine } = params
      let id = 0
      this.vLine = vLine.map(item => {
        item["id"] = ++id
        return item
      })
      this.hLine = hLine.map(item => {
        item["id"] = ++id
        return item
      })
    },
    getOffsetPosition(e) {
      let top = Number(e.offsetY) * this.zoom
      let left = Number(e.offsetX) * this.zoom
      const path = []
      this.getParentNodeByClassName(e.target, path, "vdr")
      path.some(el => {
        let classList = el.classList
        if (classList[0] === "dataGrid-cell-layout") {
          return true
        } else if ([].find.call(classList, it => it === "vdr")) {
          const position = window.getComputedStyle(el).getPropertyValue("transform")
          top += Number(position.split(",")[position.split(",").length - 1].slice(0, -1)) * this.zoom
          left += Number(position.split(",")[position.split(",").length - 2]) * this.zoom
        }
      })
      return [top, left]
    },
    getParentNodeByClassName(e, res = [], parentClass) {
      const parentNode = e.parentNode
      if (parentNode && parentNode.classList) {
        let elClasslist = parentNode.classList
        if ([].find.call(elClasslist, it => it === parentClass)) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getParentNodeByClassName(parentNode, res, parentClass)
        }
      } else {
        return res
      }
    },
    // 从菜单栏拖动组件到自动布局
    async handleDataGridDragover(e) {
      let attribute = e.dataTransfer.getData("rectAttribute")
      let childItemInfo = sessionStorage.getItem("childItemInfo")
      sessionStorage.setItem("isGridDragOver","true")
      sessionStorage.removeItem("dropOverCell")
      sessionStorage.removeItem("isDragging")
      this.isDragover = false
      childItemInfo = JSON.parse(childItemInfo)
      if (childItemInfo.childItemName === "收藏") {
        attribute = JSON.parse(attribute)
        const _attribute = await getSyetemModuleJson(attribute.encId)
        attribute = JSON.stringify(_attribute)
      }
      if (attribute) {
        attribute = JSON.parse(attribute)
        attribute.options.filedMapping = {
          value: null,
          label: null,
          flag: false,
          checked: true
        }
        if (attribute.options.linkUrl) {// 去掉跳转链接
          attribute.options.linkUrl = ""
        }
        // 拖入单元格的组件默认显示 没有该属性预览页会用透明度控制显示隐藏
        attribute.options.display = "block"
        const preventComponentMap = [
          "layoutcomponent", //布局组件
          "swiper", //轮播组件,
          "cxmultifilter", // 多级筛选
          "cxdatagrid"
        ]
        if (preventComponentMap.find(it => attribute.shape.toLowerCase().includes(it))) return
        //获取当前鼠标的left和top
        const { width, height } = attribute.options
        const { offsetWidth, offsetHeight } = this.$el
        let [left, top] = [e.offsetX, e.offsetY]
        // 处理当被拖拽组件落到已拖拽组件上的时候,offsetX 和 Y偏移量会取错的问题
        if (![].find.call(e.target.classList, it => it === "dataGrid-cell-layout")) {
          ;[top, left] = this.getOffsetPosition(e)
        }
        ;[attribute.options.left, attribute.options.top] = [left - width / 2, top - height / 2]
        const rightCheck = () => attribute.options.left + attribute.options.width > offsetWidth
        const bottomCheck = () => attribute.options.top + attribute.options.height > offsetHeight
        const leftCheck = () => attribute.options.left < 0
        const topCheck = () => attribute.options.top < 0
        while (rightCheck() || bottomCheck() || leftCheck() || topCheck()) {
          if (rightCheck()) {
            //处理右侧超出去的情况
            if (attribute.options.width <= offsetWidth) {
              attribute.options.left = offsetWidth - attribute.options.width
            } else {
              attribute.options.width = offsetWidth - attribute.options.left
            }
          }
          if (bottomCheck()) {
            //处理下侧超出去的情况
            if (attribute.options.height <= offsetHeight) {
              attribute.options.top = offsetHeight - attribute.options.height
            } else {
              attribute.options.height = offsetHeight - attribute.options.top
            }
          }
          if (leftCheck()) {
            //处理左侧超出去的情况
            attribute.options.left = 0
          }
          if (topCheck()) {
            //处理上侧超出去的情况
            attribute.options.top = 0
          }
        }
        let param = {
          ...this.myid,
          data: attribute.options
        }
        this.$store.dispatch(this.request_prefix + "/addDataGridElement", param)
      }
    },
    clickCellBox() {
      let thisIds = {
        ...this.myid,
      }
      // 需要去掉组件的选中id
      if (thisIds.cellId === "root") {
        delete thisIds.elementInDataGridId
      }
      this.$store.commit("states/changeActiveID", thisIds)
      this.$store.commit("states/changeElementType", "cxDataGridCell")
    },
    activeEv(elementOption) {
      const activeID = {
        ...this.myid,
        cellId: "root",
        elementInDataGridId: elementOption.elementInDataGridId
      }
      this.$store.commit("states/changeActiveID", activeID)
      this.$store.commit("states/changeElementType", elementOption.innerElement)
    },
    // 不需要了自动布局内的组件任何情况都能显示拖拽手柄
    checkResizable(rect) {
      let widthType = rect.hasOwnProperty("widthType") ? rect.widthType : "px"
      let heightType = rect.hasOwnProperty("heightType") ? rect.heightType : "px"
      if (widthType !== "px" && heightType !== "px") {
        return false
      }
      return true
    },
    dragstopEv(rect, elementInDataGridId, e) {
      const _opt = this.elementOptions.find(it => it.elementInDataGridId === elementInDataGridId)
      const _position = { left: _opt.left, top: _opt.top }
      //如果位置未变 就不修改
      if (
        Object.keys(_position).some(item => {
          return _position[item] !== rect[item]
        })
      ) {
        let insertIndex = this.getInsertIndexNew(e)
        if (this.options.showRowColLayout) {
          // 需要同步更新其他单元格中元素的位置
          for (let i = 0; i < this.parentOptions.cells.length; i++) {
            let elementOptions = this.parentOptions.cells[i].elementOptions
            const opt = elementOptions.find(it => it.elementInDataGridId === elementInDataGridId)
            if (insertIndex < 0 || !this.isDragover) return
            let activeIndex = elementOptions.findIndex(it => it.elementInDataGridId === elementInDataGridId)
            elementOptions.splice(activeIndex, 1) // 删除当前拖拽元素
            elementOptions.splice(insertIndex - 1, 0, opt) //插入到鼠标放到的元素位置
            this.insertIndex = null
          }
        } else {
          this.changeVGR(rect, elementInDataGridId, "left", "top")
        }
      }
      this.isDragover = false
    },
    draggingEv(rect, elementInDataGridId, e) {
      this.isDragover = true
      if (this.options.showRowColLayout) {
        this.insertIndex = this.getInsertIndexNew(e)
      }
    },
    // 获取鼠标在当前元素上的索引
    getInsertIndexNew(e) {
      let _this = this
      let top = Number(e.offsetY) //鼠标在当前元素上的位置
      let left = Number(e.offsetX)
      let _index = 0
      let targetPosition = e.target.getBoundingClientRect() // 当前元素位置
      let rowColDirection = _this.rowColDirection
      if (rowColDirection !== "horizon") {
        //垂直方向排列
        this.currentHalf = top / targetPosition.height < 0.5 ? false : true //超过元素高度一半显示在下方，否则显示在上方
      }
      if (rowColDirection === "horizon") {
        //水平方向排列
        this.currentHalf = left / targetPosition.width < 0.5 ? false : true // 超过元素宽度一半显示在后方，否则显示在前方
      }
      let parentNode = this.getTargetParent(e.target, [])
      let targetVdr = this.getTargetParent(e.target,[],'vdr') // 获取当前vdr元素
      if (parentNode.length === 0) {// 鼠标移到外层时
        // _index = _this.cellData.length
        return -1
      }
      let allChild = parentNode[0].children
      if (!allChild) return -1
      for (var i = 0; i < allChild.length; i++) {
        if (allChild[i] === targetVdr[0]) {
          _index = i
          break
        }
      }
      if (rowColDirection !== "horizon") {//垂直方向排列
        if (_index > this.activeIndex) {// 往下拖
          _index = top / targetPosition.height < 0.5 && _index > 0 ? _index - 1 : _index //超过元素高度一半保持原样，小于显示在当前元素上方
          this.currentHalf = true // 往下拖动时都显示在下方
        }
        if (_index < this.activeIndex) {// 往上拖
          _index = top / targetPosition.height < 0.5 ? _index : _index + 1 //超过元素高度一半显示在当前元素下方，小于保持原样
          this.currentHalf = false // 往上拖动时都显示在上方
        }
      }
      if (rowColDirection === "horizon") {//水平方向排列
        if (_index > this.activeIndex) {// 往右拖
          _index = left / targetPosition.width < 0.5 && _index > 0 ? _index - 1 : _index //超过元素宽度一半保持原样，小于显示在当前元素左边
          this.currentHalf = true // 往右拖动时都显示在右方
        }
        if (_index < this.activeIndex) {// 往左拖
          _index = left / targetPosition.width < 0.5 ? _index : _index + 1 //超过元素宽度一半显示在当前元素右方，小于保持原样
          this.currentHalf = false // 往左拖动时都显示在左方
        }
      }
      return _index + 1
    },
    getTargetParent(e, res = [], className) {
      const parentNode = e?.parentNode
      let parentName = className ? className : "row-col-layout"
      if (parentNode && parentNode.classList) {
        let elClasslist = parentNode.classList
        if ([].find.call(elClasslist, it => it === "myContainer")) {
          return []
        } else if ([].find.call(elClasslist, it => it === parentName)) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getTargetParent(parentNode, res, className)
        }
      } else {
        return res
      }
    },
    resizestopEv(rect, elementInDataGridId) {
      this.changeVGR(rect, elementInDataGridId, "width", "height")
    },
    resizingEv: _throttle(function (rect, elementInDataGridId) {
      this.changeVGR(rect, elementInDataGridId, "width", "height")
    }, 100),
    //封装的修改布局组件中的组件的大小和位置的函数
    changeVGR(rect, elementInDataGridId, change1, change2) {
      let param = {
        ...this.myid,
        cellId: "root",
        elementInDataGridId: elementInDataGridId,
        option_name: [change1, change2],
        option_val: [rect[change1], rect[change2]],
        isSync: true
      }
      this.$store.dispatch(this.request_prefix + "/changeDataGridOptions", param)
    },
    checkHandles() {
      return ["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"]
    },
  }
}
</script>

<style scoped>
.auto-layout-component,
.auto-layout-content {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: var(--maxWidth);
  min-width: var(--minWidth);
  max-height: var(--maxHeight);
  min-height: var(--minHeight);
}

.emptyColText {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  color: var(--thirdTextColor);
  font-size: 14px;
}

::v-deep .row-col-layout > .vdr {
  flex-shrink: 0; /* flex布局不改变子元素宽高 */
  position: relative;
  transform: none !important;
}
.isDrag-over .row-col-layout,
.row-col-layout .dragging {
  cursor: grab !important;
}
.isDrag-over .row-col-layout ::v-deep .dragging > div {
  opacity: 0.5 !important;
}
.row-col-layout.vertical > .vdr:last-child {
  margin-bottom: 0 !important;
}
.row-col-layout.horizon > .vdr:last-child {
  margin-right: 0 !important;
}

.vertical > .ghost::after {
  content: "";
  position: absolute;
  left: 0;
  width: 100%;
  height: 3px;
  background: var(--themeColor);
}
.vertical > .ghost.before::after {
  top: var(--custom-margin);
}
.vertical > .ghost.after::after {
  bottom: var(--custom-margin);
}
.vdr.before:first-child::after {/* 第一个元素前不要偏移值 */
  top: 0 !important;
  left: 0 !important;
}
.horizon > .ghost::after{
  content: "";
  position: absolute;
  top: 0;
  width: 3px;
  height: 100%;
  background: var(--themeColor);
}
.horizon > .ghost.before::after{
  left: var(--custom-margin);
}
.horizon > .ghost.after::after{
  right: var(--custom-margin);
}
.vdr.after:last-child::after {/* 最后一个元素后不要偏移值 */
  bottom: 0 !important;
  right: 0 !important;
}
.vdr_shade {
  cursor: grab !important;
}
.vdr.active > .auto-layout-component,
.vdr.vdr_hover > .auto-layout-component {
  outline: none !important;
}
.active.handle-tb,
.active.handle-bb {
  border-top: 2px dashed var(--themeColor);
}
.active.handle-lb,
.active.handle-rb {
  border-left: 2px dashed var(--themeColor);
}
</style>